import HowToRegIcon from '@mui/icons-material/HowToReg';
import { IconButton } from '@mui/material';
import { Typography } from '@mui/material';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import { BASE_COLORS } from 'lib/functions/const/colors';
import React from 'react';

interface RegisterColumnProps {
  certificateId: number;
  loading: boolean;
  onRegister: (certificateId: number) => void | Promise<void>;
}

const RegisterColumn: React.FC<RegisterColumnProps> = ({
  certificateId,
  loading,
  onRegister,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    void onRegister(certificateId);
  };

  return (
    <LightTooltip
      title={
        <Typography variant="body1" padding={1}>
          Presiona para registrar cedente y empresa
        </Typography>
      }
    >
      <IconButton
        size="small"
        onClick={handleClick}
        disabled={loading}
        sx={{
          padding: '4px',
          opacity: loading ? 0.5 : 0.7,
          '&:hover': {
            opacity: 1,
            backgroundColor: 'rgba(107, 114, 128, 0.08)',
          },
        }}
      >
        <HowToRegIcon
          sx={{
            fontSize: 18,
            color: BASE_COLORS.gray,
          }}
        />
      </IconButton>
    </LightTooltip>
  );
};

export default RegisterColumn;
